export const isWorkplacesAvailable = (state: boolean = false) => state;
